export const SHOW_STATUS_ONBOARDING_LOCALSTORAGE_KEY = 'show-status-onboarding';
export const USETIFUL_SOURCE_ONBOARDING_LOCALSTORAGE_KEY = 'tours';
